import React from "react";
import { TextField, MenuItem } from "@mui/material";
import { useSelector } from "react-redux";
import { selectUniqueCities } from "../store/propertiesSelectors";

interface CityInputProps {
  value: string;
  onChange: (city: string) => void;
  disabled?: boolean;
  size?: "small" | "medium";
}

export const CityInput: React.FC<CityInputProps> = ({
  value,
  onChange,
  disabled = false,
  size = "medium",
}) => {
  const cities = useSelector(selectUniqueCities);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value);
  };

  return (
    <TextField
      margin="dense"
      label="City"
      fullWidth
      size={size}
      value={value}
      onChange={handleChange}
      disabled={disabled}
      select
      data-testid="city-input"
    >
      <MenuItem value="">
        <em>All cities</em>
      </MenuItem>
      {cities.map((city) => (
        <MenuItem key={city} value={city}>
          {city}
        </MenuItem>
      ))}
    </TextField>
  );
};